import { AGENT } from "../data/site";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1E3A2F] text-[#F9F6F0]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-display text-3xl tracking-tight">{AGENT.business}</p>
          <p className="mt-3 text-[#E8A365] text-sm uppercase tracking-[0.2em]" data-testid="footer-brand-sub">{AGENT.logoBottom}</p>
          <p className="mt-5 text-[#F9F6F0]/70 leading-relaxed max-w-sm">
            Independent, licensed, and genuinely on your side, from your first question to every year after.
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-sm uppercase tracking-[0.2em] text-[#E8A365] mb-4">Reach {AGENT.firstName}</p>
          <a href={AGENT.phoneHref} className="flex items-center gap-3 hover:text-[#E8A365] transition-colors">
            <Phone className="w-4 h-4" /> {AGENT.phone}
          </a>
          <a href={`mailto:${AGENT.email}`} className="flex items-center gap-3 hover:text-[#E8A365] transition-colors">
            <Mail className="w-4 h-4" /> {AGENT.email}
          </a>
          <p className="flex items-center gap-3 text-[#F9F6F0]/70">
            <MapPin className="w-4 h-4" /> {AGENT.location}
          </p>
        </div>

        <div className="md:text-right">
          <p className="text-[#F9F6F0]/60 text-sm leading-relaxed">
            {AGENT.license}
          </p>
          <p className="mt-4 text-[#F9F6F0]/50 text-xs leading-relaxed max-w-sm md:ml-auto" data-testid="footer-disclaimer">
            Disclaimer: Coverage with Jacqueline is an independent health insurance service operated by Jacqueline Kane,
            a licensed Maryland health insurance agent. This website is privately operated and is not a government
            website or the official Maryland Health Connection website. Health insurance plan availability, eligibility,
            and financial assistance vary based on individual circumstances. For official Maryland Health Insurance
            Marketplace information, visit{" "}
            <a
              href="https://www.marylandhealthconnection.gov"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-mhc-link"
              className="underline underline-offset-2 text-[#F9F6F0]/80 hover:text-[#E8A365] transition-colors"
            >
              MarylandHealthConnection.gov
            </a>
            .
          </p>
        </div>
      </div>
      <div className="border-t border-[#F9F6F0]/15">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#F9F6F0]/50">
          <span>© {new Date().getFullYear()} {AGENT.business}. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#F9F6F0] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#F9F6F0] transition-colors">
              Terms of Use
            </Link>
            <span>Built with care for the people we serve.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
